import Fuse from "../classes/Fuse"

export const fuses = [
  new Fuse({
    alias: "ansi-fusible-a",
    svgSrc: "/assets/editor-symbols/ANSIFusibleSimbolo1.svg",
    label: "Fusible",
    rotable: true,
    variants: [
      {
        alias: "ansi-fusible-a",
        diagramSvgSrc: "/assets/editor-symbols/ANSIFusibleSimbolo1.svg",
        label: "Fusible ANSI 1",
        selected: false
      },
      {
        alias: "ansi-interruptor-termomagnético-a-variant1",
        diagramSvgSrc: "/assets/editor-symbols/ANSIFusibleSimbolo2.svg",
        label: "Fusible ANSI 2",
        selected: false
      },
      {
        alias: "ansi-interruptor-termomagnético-a-variantA",
        diagramSvgSrc: "/assets/editor-symbols/ANSIFusibleSimbolo3.svg",
        label: "Fusible ANSI 3",
        selected: false
      },
      {
        alias: "ansi-interruptor-termomagnético-a-IEC1",
        diagramSvgSrc: "/assets/editor-symbols/IECFusibleSimbolo1.svg",
        label: "Fusible IEC 1",
        selected: false
      },
      {
        alias: "ansi-interruptor-termomagnético-a-IEC2",
        diagramSvgSrc: "/assets/editor-symbols/IECFusibleSimbolo2.svg",
        label: "Fusible IEC 2",
        selected: false
      }
    ]
  }),
];
